/**
 * Origem Flow: navegação por Tab entre os campos do modal da linha (edição e
 * criação) — cada Tab ativa o editor do próximo campo (lista de opções aberta,
 * data com calendário, texto focado); Shift+Tab volta. Setas e Enter dentro
 * dos dropdowns já são nativos. O Tab só é interceptado quando o foco está
 * nos campos ou solto no documento — comentários, input de subtarefa e botões
 * seguem o Tab padrão do navegador.
 *
 * Requisitos do componente que usa o mixin: `ref="modal"` no <Modal> raiz e
 * campos renderizados via RowEditModalFieldsList (`.row-modal__field-item`).
 */
export default {
  data() {
    return {
      fieldWalkIndex: null,
    }
  },
  mounted() {
    this.fieldWalkKeydown = (event) => this.fieldWalkOnKeydown(event)
    document.addEventListener('keydown', this.fieldWalkKeydown)
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.fieldWalkKeydown)
  },
  methods: {
    fieldWalkOnKeydown(event) {
      const modalComponent = this.$refs.modal
      if (!modalComponent || !modalComponent.open) {
        // Qualquer tecla com o modal fechado zera o passeio — a lista de
        // campos pode ser outra na próxima abertura.
        this.fieldWalkIndex = null
        return
      }
      if (event.key !== 'Tab') {
        return
      }
      const modalEl = modalComponent.$refs.modalEl
      if (!modalEl) {
        return
      }
      const active = document.activeElement
      const insideModal = !!active && modalEl.contains(active)
      const itemEl =
        insideModal && active.closest
          ? active.closest('.row-modal__field-item')
          : null
      // Foco em outra área do modal (comentários, subtarefa, botões): Tab
      // padrão do navegador.
      if (insideModal && !itemEl) {
        return
      }
      const items = Array.from(
        modalEl.querySelectorAll('.row-modal__field-item')
      )
      if (items.length === 0) {
        return
      }
      event.preventDefault()
      event.stopPropagation()
      // Valores editados por digitação (data, texto) gravam no blur.
      if (active && active !== document.body) {
        active.blur()
      }
      // Dropdown aberto no campo atual não fecha sozinho quando o próximo
      // editor é um input (nenhum clique acontece) — um clique no body
      // aciona o click-outside dele.
      if (modalEl.querySelector('.dropdown__items:not(.hidden)')) {
        document.body.click()
      }
      const current = itemEl
        ? items.indexOf(itemEl)
        : this.fieldWalkIndex !== null && this.fieldWalkIndex < items.length
        ? this.fieldWalkIndex
        : -1
      const delta = event.shiftKey ? -1 : 1
      const total = items.length
      // Pula campos sem editor ativável (arquivo, fórmula, checkbox…) e dá a
      // volta no fim da lista.
      for (let step = 1; step <= total; step++) {
        const index = (((current + delta * step) % total) + total) % total
        if (this.fieldWalkActivate(items[index])) {
          this.fieldWalkIndex = index
          return
        }
      }
    },
    fieldWalkActivate(item) {
      const dropdownLink = item.querySelector('.dropdown__selected')
      if (dropdownLink) {
        dropdownLink.click()
        return true
      }
      // Responsável e rótulos abrem por um ButtonText próprio. Os demais
      // ButtonText (arquivo, referência) abrem modais — esses ficam de fora.
      if (
        item.classList.contains(
          'row-modal__field-item--multiple_collaborators'
        ) ||
        item.classList.contains('row-modal__field-item--multiple_select')
      ) {
        const button = item.querySelector('.button-text')
        if (button) {
          button.click()
          return true
        }
      }
      const input = item.querySelector(
        'input:not([type="hidden"]):not([disabled]), textarea'
      )
      if (input) {
        input.focus()
        return true
      }
      return false
    },
  },
}
